import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Key, Loader2 } from "lucide-react";

export default function ChangePasswordDialog({
  open, onOpenChange, newPassword, setNewPassword, confirmPassword, setConfirmPassword,
  isUpdatingPassword, handleChangePassword, t, trigger,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-foreground">{t("playerDashboard.changePassword")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <div className="space-y-2">
            <Label className="text-foreground">{t("playerDashboard.newPassword")}</Label>
            <Input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder={t("playerDashboard.enterNewPassword")} className="bg-muted border-border" data-testid="new-password-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-foreground">{t("playerDashboard.confirmPassword")}</Label>
            <Input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder={t("playerDashboard.confirmNewPassword")} className="bg-muted border-border" data-testid="confirm-password-input" />
          </div>
          <Button onClick={handleChangePassword} disabled={isUpdatingPassword} className="w-full bg-[#CCFF00] text-black hover:bg-[#CCFF00]/90" data-testid="submit-password-btn">
            {isUpdatingPassword ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Key className="h-4 w-4 mr-2" />}
            {t("playerDashboard.changePassword")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
